import type { IApiResponse } from "../../../services/api";
import { Api } from "../../../services/interceptor";
import { getAuthToken, decodeAuthTokenPayload } from "../../../helper/helper";
import type { IPlayerProfileResponse } from "../../leaguesHome/tournaments/tournamentsDetails/matches/matchesDetails/types/playerProfile";
import { QUERY_KEY } from "../../../services/queryEndPoint";

type ApiPayload<T> = T | IApiResponse<T>;

const unwrapApiPayload = <T>(payload: ApiPayload<T>): T => {
  if (payload && typeof payload === "object" && "data" in payload) {
    return payload.data as T;
  }
  return payload as T;
};

export interface ScorerDetailsRequest {
  experienceYears: number;
  city: string;
  familiarScoringMethods: string[];
  matchFormatsWorkedOn: string[];
  scoringInterfacePreferred: string[];
  feesPerMatch: number;
  feesPerDay: number;
  languagesKnown: string[];
  bio: string;
  active: boolean;
}

export interface UmpireDetailsRequest {
  location: string[];
  experience: number;
  fees: number;
  frequency: string;
  active: boolean;
}

export interface StreamerDetailsRequest {
  cameraSetup: string[];
  streamingDevice: string[];
  audioSetup: string[];
  streamingPlatforms: string[];
  pricingPerMatch: number;
  pricingPerDay: number;
  availableForPaidStreaming: boolean;
  sampleStreamLink: string;
  active: boolean;
}

export interface UpdatePlayerRoleDetailsRequest {
  scorerDetails?: ScorerDetailsRequest;
  umpireDetails?: UmpireDetailsRequest;
  streamerDetails?: StreamerDetailsRequest;
}

export const fetchUserProfile = async (): Promise<IPlayerProfileResponse> => {
  const token = getAuthToken();
  const payload = token ? decodeAuthTokenPayload(token) : null;
  const playerId = payload?.sub as string | undefined;
  const { data } = await Api.get<ApiPayload<IPlayerProfileResponse>>(
    QUERY_KEY.getPlayerProfileById.replace("playerId", playerId || ""),
  );
  return unwrapApiPayload(data);
};

export const updatePlayerRoleDetails = async (
  payload: UpdatePlayerRoleDetailsRequest,
): Promise<void> => {
  await Api.put(QUERY_KEY.updatePlayerRoleDetails, payload);
};
